document.addEventListener("DOMContentLoaded", function (event) {
  const searchButton = document.getElementById('searchButton');
  searchButton.addEventListener('click', search);

  const searchInput = document.getElementById('searchInput');
  searchInput.addEventListener('keyup', search);

  const serviceCategories = document.querySelectorAll('[data-search-category-checkbox]');
  serviceCategories.forEach((serviceCategory) => {
    serviceCategory.addEventListener('click', filter);
  });
});

function search() {
  const searchCategoryCheckboxes = document.querySelectorAll('[data-search-category-checkbox]');
  searchCategoryCheckboxes.forEach((searchCategoryCheckbox) => {
    searchCategoryCheckbox.checked = true;
  });

  const serviceWrappers = document.querySelectorAll('[data-service-wrapper-name]');
  serviceWrappers.forEach((serviceWrapper) => {
    if (matchSearchWord(serviceWrapper.dataset.serviceWrapperName)) {
      serviceWrapper.classList.remove('d-none');
    } else {
      serviceWrapper.classList.add('d-none');
    }
  });
}

function matchSearchWord(searchWord) {
  const searchInput = document.getElementById('searchInput');
  let searchValue = searchInput.value.toLowerCase();
  return new RegExp(searchValue).test(searchWord.toLowerCase());
}

function filter() {
  let searchInput = document.getElementById('searchInput');
  searchInput.value = '';

  const serviceWrappers = document.querySelectorAll('[data-service-wrapper-name]');
  serviceWrappers.forEach((serviceWrapper) => {
    serviceWrapper.classList.add('d-none');
  });

  const serviceCategories = document.querySelectorAll('[data-search-category-checkbox]');
  serviceCategories.forEach((serviceCategory) => {
    if (serviceCategory.checked) {
      const serviceWrappers = document.querySelectorAll(`[data-service-wrapper-category="${serviceCategory.dataset.searchCategoryCheckbox}"]`);
      serviceWrappers.forEach((serviceWrapper) => { serviceWrapper.classList.remove('d-none'); });
    }
  });
}
